import { Inventaire } from "@repo/types";
import {
  hasExamComplementaire,
  sanitizeEtatSanitaireGeneral,
} from "@repo/field-configs";

export type PrintHeaderVariant = 'primary' | 'alignement';

export function getPrintHeaderVariant(inventaireType?: string): PrintHeaderVariant {
  return inventaireType?.toUpperCase() === 'ALIGNEMENT' ? 'alignement' : 'primary';
}

export const containsExam = (inv: Inventaire) => {
  return hasExamComplementaire(inv.arbre?.etat_san_general);
}

export {
  hasExamComplementaire,
  sanitizeEtatSanitaireGeneral,
};

export const getStatusIsTravaux = (typeInventaire: string, inventaireSubject: Inventaire) => {
  if (typeInventaire != 'arbre') {
    if (checkArrayWithoutWorks(inventaireSubject.arbre?.travaux_collet_multiple) && inventaireSubject.arbre.etat_san_general.includes('Examen complémentaire requis')) {
      return false;
    } else {
      return true
    }
  } else {
    if (checkArrayWithoutWorks(inventaireSubject.arbre?.travaux_collet_multiple) && checkArrayWithoutWorks(inventaireSubject.arbre?.travaux_tronc_multiple) && checkArrayWithoutWorks(inventaireSubject.arbre?.travaux_houppier_multiple) && inventaireSubject.arbre?.etat_san_general.includes('exam-comple')) {
      return false;
    } else {
      return true
    }
  }
}

export const checkArrayWithoutWorks = (travaux: string[]) => {
  if (travaux.length == 0 || travaux.includes('aucun-travaux')) {
    return true;
  }
}
